"use client";

// error.tsx catches server-side errors in any page segment.
// It runs inside the normal layout (sidebar, nav remain visible).
// Errors are logged via the app logger (Pino → Cloud Run + Sentry if configured).

import { useEffect } from "react";
import { logger } from "@/lib/logger";

export default function SegmentError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error(error, {
      component: "segment_error",
      digest: error.digest,
    });
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        An unexpected error occurred while loading this page.
        {error.digest && (
          <span className="mt-1 block text-xs text-muted-foreground/60">
            Error ID: {error.digest}
          </span>
        )}
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
      >
        Try again
      </button>
    </div>
  );
}
